import { SelectGroup, SelectOption } from "../control/types";
import Dropdown, { DropdownToggleProps } from "../dropdown";

export interface DropdownButtonProps<T extends SelectOption> extends Omit<
  DropdownToggleProps,
  "onSelect"
> {
  options: SelectGroup<T>[] | T[];
  multiple?: boolean;
  clearable?: boolean;
  searchable?: boolean;
  isOptionDisabled?: (options: T) => boolean;
  onSelect?: (
    eventKey: string | null,
    e?: React.SyntheticEvent<unknown>,
  ) => void;
}

export default function DropdownButton<T extends SelectOption>(
  props: Readonly<DropdownButtonProps<T>>,
) {
  const {
    options,
    multiple = false,
    searchable = false,
    clearable = false,
    value,
    isOptionDisabled,
    onSelect,
    ...rest
  } = props;

  return (
    <Dropdown autoClose={!multiple} onSelect={onSelect}>
      <Dropdown.Toggle {...rest} />
      <Dropdown.Options
        value={value}
        options={options}
        clearable={clearable}
        searchable={searchable}
        isOptionDisabled={isOptionDisabled}
      />
    </Dropdown>
  );
}
